export default __webpack_public_path__ + "static/media/Crisis Managemet.ead507b2.png";